const GET_PROPERTY_TYPE = 'publicador/ducks/propertyType/GET_PROPERTY_TYPE';
const GET_PROPERTY_TYPE_FAILED = 'publicador/ducks/propertyType/GET_PROPERTY_TYPE_FAILED';
const GET_PROPERTY_TYPE_COMPLETED = 'publicador/ducks/propertyType/GET_PROPERTY_TYPE_COMPLETED';

const GET_SUBPROPERTY_TYPE = 'publicador/ducks/propertyType/GET_SUBPROPERTY_TYPE';
const GET_SUBPROPERTY_TYPE_FAILED = 'publicador/ducks/propertyType/GET_SUBPROPERTY_TYPE_FAILED';
const GET_SUBPROPERTY_TYPE_COMPLETED = 'publicador/ducks/propertyType/GET_SUBPROPERTY_TYPE_COMPLETED';

const GET_FORM_VALUES = 'publicador/ducks/propertyType/GET_FORM_VALUES';
const GET_FORM_VALUES_FAILED = 'publicador/ducks/propertyType/GET_FORM_VALUES_FAILED';
const GET_FORM_VALUES_COMPLETED = 'publicador/ducks/propertyType/GET_FORM_VALUES_COMPLETED';
const RESET_INFO = 'publicador/ducks/propertyType/RESET_INFO';

export {
  GET_PROPERTY_TYPE,
  GET_PROPERTY_TYPE_FAILED,
  GET_PROPERTY_TYPE_COMPLETED,
  GET_SUBPROPERTY_TYPE,
  GET_SUBPROPERTY_TYPE_FAILED,
  GET_SUBPROPERTY_TYPE_COMPLETED,
  GET_FORM_VALUES,
  GET_FORM_VALUES_FAILED,
  GET_FORM_VALUES_COMPLETED,
  RESET_INFO
};
